module.exports = __webpack_public_path__ + "img/IMG-20180802-WA0013.060a9f40.jpg";